module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_24",
      "title": "24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1954")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("There were no Hugo Awards in 1954.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The 1954 International Fantasy Awards considered "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Demolished Man")]), _vm._v(" and Theodore Sturgeon’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("More Than Human")]), _vm._v(". "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("More Than Human")]), _vm._v(" should definitely have been a Hugo nominee if it was eligible. It’s another enduring classic, Sturgeon at his best and on his favorite topic.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "ePub_SC_B"
  }, [_vm._v("OMMENTS ON")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1954")])]), _vm._v(" "), _c('p', {
    staticClass: "H2F"
  }, [_vm._v("6. R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ICH")]), _vm._v(" H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ORTON")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The list for the awards that might have been, in 1954, is "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("REALLY REALLY")]), _vm._v(" impressive, as the Retro Hugo nominees from a few years ago show: "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Caves of Steel,")]), _vm._v(" by Isaac Asimov; "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fahrenheit 451,")]), _vm._v(" by Ray Bradbury; "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Childhood’s End,")]), _vm._v(" by Arthur C. Clarke; "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Mission of Gravity,")]), _vm._v(" by Hal Clement; and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("More Than Human,")]), _vm._v(" by Theodore Sturgeon. (Other potential choices, not as good but still quite good: Robert A. Heinlein’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Revolt in 2100")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Starman Jones,")]), _vm._v(" Fritz Leiber’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Sinful Ones")]), _vm._v(" and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Green Millennium,")]), _vm._v(" John Wyndham’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Kraken Wakes")]), _vm._v(" aka "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Out of the Deeps,")]), _vm._v(" Ward Moore’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bring the Jubilee,")]), _vm._v(" and Wilmar Shiras’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Children of the Atom.")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ac7106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0